import * as types from './constants';

// Add Campaign Users
export const addCampaignUsersRequest = data => (
  { type: types.ADD_CAMPAIGN_USERS_REQUEST, payload: data }
);

export const addCampaignUsersDone = data => (
  { type: types.ADD_CAMPAIGN_USERS_DONE, payload: data }
);

export const addCampaignUsersFailed = errors => (
  { type: types.ADD_CAMPAIGN_USERS_FAILED, payload: errors }
);